import { SubscriptionType } from '@symon-ai/wisepipe-common';
export const newOrgEventSchema = {
    $id: 'urn:wisepipe-common-auth:NewOrgEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        credits: { type: 'number' },
        seats: { type: 'number', minimum: 1 },
        orgPlan: { type: 'string' },
        subscriptionType: { type: 'string', enum: Object.values(SubscriptionType) }
    },
    required: ['orgID', 'credits', 'seats', 'orgPlan']
};
//# sourceMappingURL=newOrgEvent.js.map